export const GET_NOTES = "GET_NOTES";
export const GET_NOTE_BY_ID = "GET_NOTE_BY_ID";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const CREATE_NOTE = "CREATE_NOTE";
